// extracted by mini-css-extract-plugin
module.exports = {"container":"ff","disabled":"gf","bgBlack":"hf","content":"if","countdown":"jf","topCaption":"kf","topHeading":"lf","heading":"mf","copy":"nf"};